import React from 'react';
import { Badge } from '../ui/badge';
import PortfolioCard from '../cards/PortfolioCard';
import { mockData } from '../../mock';

const PortfolioSection = ({ 
  portfolioCarouselIndexes, 
  handleNextImage, 
  handlePrevImage, 
  handleGoToImage 
}) => {
  return (
    <section id="portfolio" className="py-20 px-6 bg-gradient-to-b from-[#0a0a0a] to-[#111111] relative overflow-hidden">
      {/* Enhanced 3D Background Effect with Animation */}
      <div className="absolute inset-0 opacity-30">
        <div className="absolute top-20 left-10 w-96 h-96 bg-[#2F6BFF]/10 rounded-full blur-3xl animate-pulse"></div>
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-[#4DA3FF]/5 rounded-full blur-3xl animate-pulse" style={{ animationDelay: '1s' }}></div>
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-[#2F6BFF]/5 rounded-full blur-3xl animate-pulse" style={{ animationDelay: '2s' }}></div>
      </div>
      
      <div className="container mx-auto max-w-6xl relative z-10">
        <div className="text-center mb-16">
          <Badge className="inline-flex items-center justify-center px-4 py-1.5 bg-gradient-to-r from-[#2F6BFF]/10 to-[#4DA3FF]/10 text-[#2F6BFF] border border-[#2F6BFF]/20 rounded-full text-sm font-medium mb-6 hover:from-[#2F6BFF]/20 hover:to-[#4DA3FF]/20 transition-all duration-300">
            Portfolio
          </Badge>
          <h2 className="text-4xl md:text-5xl font-bold mb-4">Example Projects</h2>
          <p className="text-[#9AA3B2] text-lg">Real website designs created for local businesses across London.</p>
        </div>
        <div className="grid md:grid-cols-2 gap-8">
          {mockData.portfolio.map((project, index) => {
            const currentImageIndex = portfolioCarouselIndexes[project.id];
            
            return (
              <PortfolioCard
                key={project.id}
                project={project}
                index={index}
                currentImageIndex={currentImageIndex}
                nextImage={() => handleNextImage(project.id, project.images.length)}
                prevImage={() => handlePrevImage(project.id, project.images.length)}
                goToImage={(idx) => handleGoToImage(project.id, idx)}
              />
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default PortfolioSection;
